<template>
  <div class="multi-rms">
    <el-row :gutter="20">
      <template v-for="cols in snGroup">
        <template v-for="sn in cols">
          <el-col :span="24 / cols.length" :key="sn">
            <RMS :sn="sn" :key="sn" :deviceType="deviceType" :eventId="eventId" />
          </el-col>
        </template>
      </template>
    </el-row>
  </div>
</template>

<script>
import RMS from './RMS.vue';

import { mapState } from 'vuex';
import { getDeviceGroupById } from '@/api/devices';
import { awaitTo } from '@/utils/utils';

export default {
  components: { RMS },
  props: {
    sn: {
      type: String,
      default: ''
    },
    deviceType: {
      type: String,
      default: ''
    },
    eventId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      snList: []
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap']),
    snGroup() {
      const col = 2;
      const row = Math.ceil(this.snList.length / col);

      return Array(row)
        .fill(0)
        .map((_, i) => this.snList.slice(i * col, (i + 1) * col));
    },
    isHisDetail() {
      return !!this.eventId;
    }
  },
  methods: {
    // ...mapActions('mqtt', ['subDeviceBasicData', 'initMqtt']),
    async getDeviceGroup() {
      const combinationId = this.deviceSNMap[this.sn].combinationId;

      if (!combinationId) {
        return this.snList.splice(0, Infinity, this.sn);
      }

      const [err, res] = await awaitTo(getDeviceGroupById({ combinationId }));
      if (err) {
        return console.error('[RMS]未获取到设备组合ID---', err);
      }
      if (res.data.link) {
        this.snList.splice(
          0,
          Infinity,
          ...res.data.link.map(e => e.sn).filter(e => !!this.deviceSNMap[e])
        );
      }
    }
  },
  created() {
    if (this.isHisDetail) {
      this.snList.splice(0, Infinity, this.sn);
    } else {
      this.getDeviceGroup();
    }

    // this.initMqtt();
    // this.subDeviceBasicData();
  }
};
</script>

<style lang="scss">
.multi-rms {
  height: 100%;

  .el-row {
    height: 100%;

    .el-col {
      height: 100%;
    }
  }
}
</style>
